import FormPages from "../../config/FormPages";
import {IrrevocableTrust} from "../../model/IrrevocableTrust";
import {validateBasicInformation} from "../page/BasicInformationValidator";
import {FormValidationErrors, ValidationError} from "../ValidationTypes";
import {validateBeneficiariesAtFirstDeath} from "../page/BeneficiariesAtFirstDeathValidator";
import {EstateFlowchartState} from "../../model/EstateFlowchartTypes";

/**
 * Validates the form based on the current page and trust data.
 *
 * @param {string} pageName - The current page name of the form being validated.
 * @param {IrrevocableTrust} trust - The trust data to validate against.
 * @param enableEstateFlowchartMVPRelease
 * @param {EstateFlowchartState[]} flowcharts - The list of estate flowcharts for context in validation.
 * @param {string} flowchartId - The ID of the current flowchart being edited.
 * @returns {{formHasErrors: boolean, errors: any}} An object containing a boolean indicating if the form has errors and an object with the specific errors.
 */
export const validateForm = (pageName: string | undefined, trust: IrrevocableTrust | undefined, enableEstateFlowchartMVPRelease: boolean,
                             flowcharts: EstateFlowchartState[], flowchartId: string,): FormValidationErrors => {
    let errors : ValidationError[] = [];

    if(trust) {
        switch (pageName) {
            case FormPages.BASIC_INFORMATION.id:
                errors = validateBasicInformation(trust, flowcharts, flowchartId, enableEstateFlowchartMVPRelease);
                break;
            case FormPages.BENEFICIARIES_AT_FIRST_DEATH.id:
                if(trust.firstDeathBeneficiaries?.firstDeathDistributions) {
                    errors = validateBeneficiariesAtFirstDeath(trust?.firstDeathBeneficiaries?.firstDeathDistributions, enableEstateFlowchartMVPRelease);
                }
                break;
        }
    }

    return {
        formHasErrors: errors.length > 0,
        errors: errors
    };
}